import { ContainerModule } from '@evertel/di'
import { BlueUserStore } from './store'
import { CurrentUserController, ResetPasswordController, UserInvitesSearchController, UserController, UsersSearchController, CurrentUserDepartmentsController,
    UnreadCountsState, UserSettingsController, UserWidgetController,
    DeviceSettingsController
} from './controllers'
import { FetchUserService, CurrentUserPollService } from './services'


const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(BlueUserStore).toSelf().inSingletonScope()
        m.bind(UnreadCountsState).toSelf().inSingletonScope()
        m.bind(FetchUserService).toSelf().inSingletonScope()
        m.bind(CurrentUserPollService).toSelf().inSingletonScope()

        m.bind(UserInvitesSearchController).toSelf()
        m.bind(CurrentUserController).toSelf()
        m.bind(UserController).toSelf()
        m.bind(UsersSearchController).toSelf()
        m.bind(CurrentUserDepartmentsController).toSelf()
        m.bind(UserSettingsController).toSelf()
        m.bind(UserWidgetController).toSelf()
        m.bind(DeviceSettingsController).toSelf()

        m.bind(ResetPasswordController).toSelf().inSingletonScope()
    })
]

export { DI_MODULES }
